<template>
  <v-row v-if="viewMode == 'list'">
    <v-col cols="12">
      <v-btn-toggle
        v-model="tableDisplay"
        tile
        color="deep-purple accent-3"
        group
        class="text-center"
        rounded
        mandatory
      >
        <v-btn value="records">
          Record Filings
        </v-btn>
        <v-btn value="record_requests">
          Record Requests
        </v-btn>
      </v-btn-toggle>
    </v-col>
    <RecordsListTable :tableDisplay="tableDisplay" :isFetching="isFetching" :search="search"/>
    <RecordRequestsTable :tableDisplay="tableDisplay" />
  </v-row>
</template>

<script>
  import RecordsListTable from "./RecordsListTable";
  import RecordRequestsTable from './RecordRequestsTable';

  export default {
    name: "RecordsViewList",
    components: {
      RecordsListTable,
      RecordRequestsTable
    },
    props: {
      viewMode: String,
      search: String,
      routeAccess: Boolean,
      routeId: Number,
      routeType: String,
      subRouteIndex: Number,
      parentRouteId: String,
      requestId: Number,
      isFetching: Boolean,
    },
    data() {
      return {
        tableDisplay: "record_requests",
      };
    },
    mounted() {
      
    }
  };
</script>

<style></style>
